import { render, staticRenderFns } from "./UploadInstrumentImg.vue?vue&type=template&id=a9da7bfc"
import script from "./UploadInstrumentImg.vue?vue&type=script&lang=ts"
export * from "./UploadInstrumentImg.vue?vue&type=script&lang=ts"
import style0 from "./UploadInstrumentImg.vue?vue&type=style&index=0&id=a9da7bfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports